import Error from 'next/error'
import { PAGINEDETAIL, CATALOGHI } from '../../utils/endpoint'
import { api, getApiClient } from '../../utils'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import RichiestaCatalogoTemplate from '../../components/template/RichiestaCatalogoTemplate/RichiestaCatalogoTemplate'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'

const RichiestaCatalogo = ({ page, cataloghi, reload }) => {
  const { utente, fetched, error, pending } = useSelector((state) => state.utente)
  const router = useRouter()

  useEffect(() => {
    if (!utente && fetched) {
      router.push(`${router.locale}/myaccount/accedi`)
    }
  }, [utente])

  return <>{utente && <RichiestaCatalogoTemplate cataloghi={cataloghi} page={page} />}</>
}

export async function getServerSideProps({ locale, req, query }) {
  const api = getApiClient(req)
  let reload = false
  if (query.reload) {
    reload = true
  }
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: { chiave: 'richiesta-catalogo', lang: locale },
  })
  const page = await pageResponse.data
  const cataloghiResponse = await api.get(CATALOGHI, {
    params: { lang: locale },
  })
  const cataloghi = await cataloghiResponse.data

  const toolbarProps = { toolbarPage: page }
  return {
    props: { page, cataloghi, reload, ...toolbarProps },
  }
}

RichiestaCatalogo.propTypes = {
  page: PropTypes.object,
}

export default RichiestaCatalogo
